import RightArrow from 'icons/mine/arrow2.svg';
import DFHIcon from 'icons/mine/daifahuo.svg';
import DFKIcon from 'icons/mine/daifukuan.svg';
import DQRIcon from 'icons/mine/daiqueren.svg';
import DSPIcon from 'icons/mine/daishenpi.svg';
import DSHIcon from 'icons/mine/daishouhuo.svg';
import DWCIcon from 'icons/mine/daiwancheng.svg';
import DDIcon from 'icons/mine/dingdanguanli.svg';
import FHIcon from 'icons/mine/fahuoguanli.svg';
import FPTT from 'icons/mine/fapiaotaitouguanli.svg';
import SPIcon from 'icons/mine/shenpi.svg';
import SHDZ from 'icons/mine/shouhuodizhiguanli.svg';
import SHIcon from 'icons/mine/shouhuoguanli.svg';
import SHZIcon from 'icons/mine/shouhuozhong.svg';
import TCDL from 'icons/mine/tuichudenglu.svg';
import THIcon from 'icons/mine/xiaoxi.svg';
import TODOIcon from 'icons/mine/daiban.svg';
import dp from 'images/tx.png';
import dpW from 'images/txw.webp';
import THHIcon from 'icons/mine/return.svg';
import ServiceIcon from 'icons/mine/service.svg';
import DDIcon2 from 'icons/gengduo2.svg';
import YFHIcon from 'icons/mine/yifahuo.svg';
import ZFIcon from 'icons/mine/zhifu.svg';
import JSIcon from 'icons/mine/jiesuan.svg';
import LSIcon from 'icons/mine/history.svg';
import SCIcon from 'icons/mine/collect.svg';
import EnquiryIcon from 'icons/mine/enquiry.svg';
import ContractIcon from 'icons/mine/contract.svg';

export const IMGS = {
  RightArrow,
  DFHIcon,
  DFKIcon,
  DQRIcon,
  DSPIcon,
  DSHIcon,
  DWCIcon,
  DDIcon,
  FHIcon,
  FPTT,
  SPIcon,
  SHDZ,
  SHIcon,
  SHZIcon,
  TCDL,
  THIcon,
  TODOIcon,
  dp,
  dpW,
  ServiceIcon,
  DDIcon2,
  YFHIcon,
  ZFIcon,
  JSIcon,
  LSIcon,
  SCIcon,
  THHIcon,
  EnquiryIcon,
  ContractIcon,
};
